import React from 'react'
import Button from '../../blocks/Button';
import { useTranslation } from 'react-i18next';

export default function BadgingControls(props) {
  const {
    awardableBadges,
    printableBadges,
    selectedRows,
    onAwardBadges,
    onPrintBadges,
    buildCertificates,
    waiting,
  } = props;

  const {t} = useTranslation("badging_report");
  
  return (
    <div className='badgingControls'>
      <Button
        onClick={onAwardBadges}
        disabled={awardableBadges.length === 0}
        waiting={waiting}
      >
        {t("awardButton", {count: awardableBadges.length})}
      </Button>
      <Button
        onClick={onPrintBadges}
        disabled={printableBadges.length === 0}
      >
        {t("printButton", {count: printableBadges.length})}
      </Button>
      <Button
        onClick={buildCertificates}
        disabled={selectedRows.length === 0}
      >
        {t("Build Certificates")}
      </Button>
    </div>
  )
}